"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_grid_layout_1 = require("react-grid-layout");
const defaultResponsiveGridlayoutProps = {
    isDraggable: false,
    isResizable: false,
    breakpoints: {
        lg: 1280,
        md: 960,
        sm: 600,
        xs: 0,
    },
    cols: {
        lg: 12,
        md: 8,
        sm: 4,
        xs: 2,
    },
    margin: [16, 16],
    containerPadding: [16, 16],
    rowHeight: 55,
};
/**
 * A wrapper around {@link react-grid-layout | https://github.com/react-grid-layout/react-grid-layout} providing a default set of props
 * This component is intended to be used with the GridCard component on view pages to layout key data of an entity.
 *
 *  * Important to note when creating the layouts:
 *  - You should define a layout for each breakpoint so this component knows how to arrange cards on multiple screen sizes.
 *  - The number of columns changes for each screen size
 *
 * For each layout object:
 *  - i refers to the unique key for each card.
 *  - x is the 0 indexed, horizontal position of a card. If it overlaps with another card, it will get pushed down
 *  - y is the 0 indexed, vertical position of a card. If it overlaps it will get pushed to the right.
 *  - w is the width (number of columns) for the card to occupy. You can also use minW or maxW
 *  - h is the height (number of rows) for the card to occupy. You can also use minH or maxH
 *
 * @example Basic usage
 * ```tsx
 * . const layouts = {
 *     lg: [
 *       { i: "card1", x: 0, y: 0, w: 4, h: 4 },
 *       { i: "card2", x: 4, y: 0, w: 4, h: 4 },
 *     ],
 *     md: [
 *       { i: "card1", x: 0, y: 0, w: 4, h: 4 },
 *       { i: "card2", x: 4, y: 0, w: 4, h: 4 },
 *     ],
 *   };
 *
 * //This example uses the Card component from Material UI BUT we should be using @mnemonic/mui5´s GridCard Component. This
 * //example should be updated if still using Card from Material UI
 *   const Component = (
 *     <GridLayout layouts={layouts}>
 *       <Card key="card1">
 *         <CardHeader title="Card 1 header" />
 *         <CardContent>This is the card content</CardContent>
 *       </Card>
 *       <Card key="card2">
 *         <CardHeader title="Card 2 header" />
 *         <CardContent>This is the card content</CardContent>
 *       </Card>
 *     </GridLayout>
 *   );
 * ```
 * @category component
 */
const GridLayout = (props) => {
    const { children, layouts, ...restResponsiveProps } = props;
    const ResponsiveGridLayout = (0, react_1.useMemo)(() => (0, react_grid_layout_1.WidthProvider)(react_grid_layout_1.Responsive), []);
    return (react_1.default.createElement(ResponsiveGridLayout, { layouts: layouts, ...defaultResponsiveGridlayoutProps, ...restResponsiveProps, style: { position: "relative" } }, children));
};
exports.default = GridLayout;
